import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "common-ui-components/components/utils/API";
import HorizontalTabs from "common-ui-components/components/horizontal-tabs/HorizontalTabs";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import InfoBoxRedirectButton from "app/common/InfoBoxRedirectButton";
import EndOfLifeSoftwareList from "../../../view/High Risk Software/table-view/EndOfLifeSoftwareList";
import CategorySoftwareList from "../../../view/High Risk Software/table-view/CategorySoftwareList";
import {
  isEndOfLifeCategory,
  mergeHighRiskSoftwareCategories,
} from "../../../view/High Risk Software/highRiskSoftwareUtils";
import styles from "./HighRiskSoftwareOverview.module.css";

const HighRiskSoftwareOverview = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadCategories = async () => {
      try {
        const response = await API.get(
          "vulnerabilities/high-risk-software-categories",
        );
        if (isMounted && response?.status?.success) {
          const result = mergeHighRiskSoftwareCategories(response.body || []);
          setCategories(result);
        }
      } catch (error) {
        console.error("Failed to load high-risk software categories.", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadCategories();
    return () => {
      isMounted = false;
    };
  }, []);

  const tabs = categories.map((category) => ({
    key: category.categoryName,
    header: (
      <span className={styles.tabHeader}>
        <span>{category.categoryName}</span>
        <span className={styles.categoryCount}>{category.softwareCount}</span>
      </span>
    ),
    children: isEndOfLifeCategory(category) ? (
      <EndOfLifeSoftwareList preview />
    ) : (
      <CategorySoftwareList categoryName={category.categoryName} preview />
    ),
  }));

  return (
    <InfoBox
      header="High Risk Software"
      subtitle="Software categories that increase your attack surface"
      badge={
        <InfoBoxRedirectButton
          onClick={() => navigate("/app/secure/threats/high-risk-software")}
          label="View all high-risk software"
        />
      }
      badgeProps={{ className: styles.redirectBadge }}
      style={{ width: "100%", minWidth: 0 }}
      childrenProps={{ className: styles.infoBoxContent }}
      loading={loading}
    >
      {loading ? (
        <div className={styles.message} role="status">
          Loading categories...
        </div>
      ) : categories.length === 0 ? (
        <div className={styles.message}>No high-risk software found.</div>
      ) : (
        <HorizontalTabs
          tabs={tabs}
          initialTabIndex={0}
          containerProps={{ className: styles.tabs }}
        />
      )}
    </InfoBox>
  );
};

export default HighRiskSoftwareOverview;
